import { render, staticRenderFns } from "./MatchBaseDrawer.vue?vue&type=template&id=383d87c4&scoped=true"
import script from "./MatchBaseDrawer.vue?vue&type=script&lang=js"
export * from "./MatchBaseDrawer.vue?vue&type=script&lang=js"
import style0 from "./MatchBaseDrawer.vue?vue&type=style&index=0&id=383d87c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d87c4",
  null
  
)

export default component.exports